import React from 'react'
import { config } from 'enviroment.js'
import axios from 'axios'
import { message, Empty, Button } from 'antd'
import {
  DndContext,
  closestCenter,
  KeyboardSensor,
  PointerSensor,
  useSensor,
  useSensors,
} from '@dnd-kit/core'
import {
  arrayMove,
  SortableContext,
  sortableKeyboardCoordinates,
} from '@dnd-kit/sortable'
import 'antd/dist/antd.css'
import 'Pages/Admin/Admin.scss'
import { getCookie } from 'common/utils/auth'
import InventoryItem from 'Pages/Admin/Components/InventoryItem'

const headers = {
  'Content-Type': 'application/json',
  Authorization: `Bearer ${getCookie('token')}`,
}

function ItemSection(props) {
  const {
    itemType,
    items,
    expInfo,
    setVisible,
    setActiveItem,
    setLoading,
    setItems,
  } = props
  const sensors = useSensors(
    useSensor(PointerSensor),
    useSensor(KeyboardSensor, {
      coordinateGetter: sortableKeyboardCoordinates,
    })
  )

  let itemTypeStr, emptyStr, addButtonText
  switch (itemType) {
    case 2:
      itemTypeStr = 'Locks'
      emptyStr = 'There are no locks for this experience.'
      addButtonText = 'Add Lock'
      break
    case 501:
      itemTypeStr = 'Toys'
      emptyStr = 'There are no toys for this experience.'
      addButtonText = 'Add Toy'
      break
    default:
      itemTypeStr = 'Inventory'
      emptyStr = 'There is no inventory for this experience.'
      addButtonText = 'Add Inventory'
  }

  const openAddItemModal = () => {
    setVisible(true)
    setActiveItem({
      actionType: 'add',
      inventoryType: itemType,
      xExperienceId: expInfo.xExperienceId,
    })
  }

  function handleDragEnd(event) {
    const { active, over } = event
    const oldIndex = items.findIndex((item) => item.id === active.id)
    const newIndex = items.findIndex((item) => item.id === over.id)
    const selectedItem = items[oldIndex]
    const overItem = items[newIndex]
    if (active.id !== over.id) {
      setLoading({ status: true, type: 'action' })
      setItems((items) => {
        return arrayMove(items, oldIndex, newIndex)
      })
      const needsReorder =
        items.filter((item) =>
          [selectedItem.orderNumber, overItem.orderNumber].includes(
            item.orderNumber
          )
        ).length > 2
      axios
        .post(
          config.raUrl +
            `/admin/experiences/${selectedItem.xExperienceId}/updateOrder/?reorder=${needsReorder}`,
          {
            selectedItemId: selectedItem.id,
            selectedItemOrder: selectedItem.orderNumber,
            overItemOrder: overItem.orderNumber,
            inventoryType: selectedItem.inventoryType,
            selectedIndex: oldIndex,
            overIndex: newIndex,
          },
          { headers }
        )
        .then((res) => {
          setItems(res.data)
          setLoading({ status: false })
          message.success('Item order updated!')
        })
        .catch((err) => {
          console.log('error caught: ', err)
          message.error('Something went wrong!')
        })
    }
  }

  return (
    <div className="section-container">
      <div className="section-header">
        <div className="section-header-title">{itemTypeStr}</div>
        <Button
          type="primary"
          size="small"
          className="action-btn"
          onClick={openAddItemModal}
        >
          {addButtonText}
        </Button>
      </div>
      <div className="section-items">
        {items.length > 0 ? (
          <DndContext
            sensors={sensors}
            collisionDetection={closestCenter}
            onDragEnd={handleDragEnd}
          >
            <SortableContext items={items}>
              {items.map((el) => (
                <InventoryItem
                  key={el.id}
                  id={el.id}
                  el={el}
                  setVisible={setVisible}
                  setActiveItem={setActiveItem}
                />
              ))}
            </SortableContext>
          </DndContext>
        ) : (
          <Empty description={<span>{emptyStr}</span>} />
        )}
      </div>
    </div>
  )
}
export default ItemSection
